import { WebClientDetailFetcher } from '~commonInfra/utils/resourceFetchers/WebClientDetailFetcher';
import { WebClientListResourceFetcher } from '~commonInfra/utils/resourceFetchers/WebClientListResourceFetcher';

import { IResult } from '../../httpClient/serverApi/types/IResponse';
import { RequestHelper } from '../../httpClient/utils/RequestHelper';
import { ResultHelper } from '../../httpClient/utils/ResultHelper';
import WebHttpClient from '../../httpClient/WebHttpClient';
import { WebHttpClientWithErrorToastInstance } from '../../httpClient/WebHttpClientWithErrorToast';
import { IDetailFetcher } from '../../ts/fetchers/IDetailFetcher';
import { IListFetcher } from '../../ts/fetchers/IListFetcher';
import { ServerApiMapper } from '../../ts/helpers/ServerModelHelper';
import { FieldValuesQuery } from '../../ts/resources/FieldValuesQuery';
import { IActionResource, IDetailResource, IFieldValuesResource, IListResource } from '../../ts/resources/Resource';
import { ResourceQuery } from '../../ts/resources/ResourceQuery';
import { GetFieldValuesRequest } from '../../ts/ServerApi/requests/GetFieldValuesRequest';
import { IFieldValue } from '../../ts/ServerApi/types/IFieldValue';
import { IDataRoleDetailInfo, IDataRoleInfo } from '../models/IDataRoleInfo';
import { DataRoleMapper } from '../models/mappers/DataRoleMapper';
import { DeleteDataRolesRequest } from '../serverApi/requests/DeleteDataRolesRequest';
import { GetDataRoleActionsRequest } from '../serverApi/requests/GetDataRoleActionsRequest';
import { GetDataRolesRequest } from '../serverApi/requests/GetDataRolesRequest';
import { MoveDataRolesToProjectRequest } from '../serverApi/requests/MoveDataRolesToProjectRequest';
import { SetDataRolesOwnerRequest } from '../serverApi/requests/SetDataRolesOwnerRequest';
import { IDataRoleActions } from '../serverApi/types/IDataRoleActions';

export class DataRolesResource implements IListResource<IDataRoleInfo>, IFieldValuesResource, IDetailResource<IDataRoleDetailInfo>, IActionResource<IDataRoleActions> {
  private listFetcher: IListFetcher<IDataRoleInfo> = new WebClientListResourceFetcher(GetDataRolesRequest, ServerApiMapper.dataRoles);
  private detailFetcher: IDetailFetcher<IDataRoleDetailInfo> = new WebClientDetailFetcher('getDataRole', DataRoleMapper.mapDetail);
  private fieldValuesFetcher: IListFetcher<IFieldValue> =  new WebClientListResourceFetcher(GetFieldValuesRequest, ServerApiMapper.fieldValues);

  public all(): ResourceQuery<IDataRoleInfo> {
    return new ResourceQuery(this.listFetcher);
  }

  public getById(id: string): Promise<IDataRoleDetailInfo> {
    return this.detailFetcher.fetchById(id);
  }

  public valuesForField(field: string): FieldValuesQuery {
    return new FieldValuesQuery(this.fieldValuesFetcher, field, 'dataRole');
  }

  // Actions
  public actions(id: string): Promise<IDataRoleActions> {
    return WebHttpClient.sendRequest(new GetDataRoleActionsRequest(id));
  }

  public deleteDataRoles(ids: string[]): Promise<IResult> {
    return WebHttpClientWithErrorToastInstance.sendRequestsAndDelay(
      RequestHelper.buildRequests(ids, (idsBlock) => new DeleteDataRolesRequest(idsBlock)),
      ResultHelper.combineResults
    );
  }

  public moveToProject(targetProjectId: string, dataRoleIds: string[]): Promise<IResult> {
    return WebHttpClientWithErrorToastInstance.sendRequestsAndDelay(
      RequestHelper.buildRequests(dataRoleIds, (idsBlock) => new MoveDataRolesToProjectRequest({
        ids: idsBlock,
        projectId: targetProjectId
      })),
      ResultHelper.combineResults);
  }

  public setOwner(ids: string[], ownerId: string): Promise<IResult> {
    return WebHttpClientWithErrorToastInstance.sendRequestsAndDelay(
      RequestHelper.buildRequests(ids, (idsBlock) => new SetDataRolesOwnerRequest(idsBlock, ownerId)),
      ResultHelper.combineResults);
  }

  public isDataRoleDetailedInfo(item: any): item is IDataRoleDetailInfo {
    return item &&
           item.contentType &&
           item.contentType === 'dataRole' &&
           item.hasOwnProperty('dataTypes');
  }
}

export const DataRoles = new DataRolesResource();
